<iframe
    title="compas-help-story"
    class="h-100 w-100 d-block border-0"
    [src]="_url"
>
</iframe>
